import React, { Component } from 'react'
import "./loader.css"
const Loader = ({props}) => {
    return <li className='loader-animation'></li>
}
export default Loader;


// WEBPACK FOOTER //
// ./src/commonUI/infiniteLoad/loader.js